import { j as t } from "./jsx-runtime.DGlMoOmv.js";
import * as r from "react";
import { T as a } from "./Text.BGhoO_e3.js";
import { c as i } from "./index.CxSWpsOB.js";
const s = (e, o) => /* @__PURE__ */ t.jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: 16, height: 16, fill: "currentColor", viewBox: "0 0 16 16", ref: o, ...e, children: [
  /* @__PURE__ */ t.jsx("path", { fill: "currentColor", d: "M5.694 6.712C5.253 5.514 6.15 4 7.884 4c.807 0 1.448.246 1.89.67.44.422.643.982.643 1.529 0 .95-.69 1.47-1.145 1.813l-.043.032c-.24.181-.42.317-.553.468-.124.14-.175.261-.175.405a.5.5 0 0 1-1 0c0-.45.188-.797.424-1.065.203-.232.464-.427.678-.588l.055-.042c.504-.38.76-.623.76-1.023a1.1 1.1 0 0 0-.335-.807C8.86 5.18 8.485 5 7.883 5c-1.082 0-1.436.864-1.25 1.366a.5.5 0 1 1-.94.346ZM8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z" }),
  /* @__PURE__ */ t.jsx("path", { fill: "currentColor", d: "M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8Zm7-6a6 6 0 1 0 0 12A6 6 0 0 0 8 2Z" })
] }), p = r.forwardRef(s), l = ({
  children: e,
  className: o
}) => /* @__PURE__ */ t.jsx(a, { className: i("tw-mb-16", o), element: "h3", typeface: "headline-3-m", children: e });
l.displayName = "PriceLineItemTooltipTitle";
export {
  p as F,
  l as P
};
//# sourceMappingURL=PriceLineItemTooltipTitle.BDwjLtsr.js.map
